import type { SocialsIndexType } from "./types";

export const SOCIALS: SocialsIndexType = {
  chewyswap: {
    website: "https://chewyswap.dog",
    other: [
      "https://chewyswap.dog",
      "https://t.me/chewyswapcommunity",
      "https://x.com/chewyswap",
      "https://github.com/chewyswap",
    ],
  },
  dcent: {
    website: "https://Dcent.live",
    other: [
      "https://t.me/shibarcade",
      "https://x.com/shibarcade",
    ],
  },
  ltd: {
    website: "https://ltdtoken.com",
    other: [
      "https://ltdtoken.com",
      "https://t.me/Ltdtoken",
      "https://x.com/theLTDtoken",
    ],
  },
  fef: {
    website: "https://fef.solutions/",
    other: ["https://fef.solutions/",
		"https://t.me/fef_token",
		"https://x.com/FEF_TOKEN"
	],
  },
  shiro: {
    website: "https://shironeko.gg",
    other: [
      "https://shironeko.gg",
      "https://x.com/shiro",
      "https://t.me/shironeko_portal",
    ],
  },
  cent: {
    website: "https://fef.solutions/1-cent-dream-cent",
    other: ["https://t.me/CENT_1CENTDREAM", "https://x.com/1cDream"],
  },
  shifu: {
    website: "https://shifutoken.com/",
    other: ["https://x.com/Shifutokencom", "https://t.me/shifu_disciples"],
  },
  roar: {
    website: "https://ogroaringkitty.com/",
    other: [
      "https://ogroaringkitty.com/",
      "https://t.me/OgRoaringKitty",
      "https://x.com/RoaringKitty_22",
    ],
  },
  skullz: {
    website: "https://skullz.vip",
    other: [
      "https://skullz.vip",
      "https://x.com/RadballsCircus",
      "https://t.me/BadFleaCircus",
    ],
  },
  bury: {
    website: "https://burythebone.in",
    other: [
      "https://burythebone.in",
      "https://t.me/BuryTheBone",
      "https://x.com/TeamBury",
    ],
  },
  knine: {
    website: "https://www.k9finance.com/",
    other: [
      "https://www.k9finance.com/",
      "https://t.me/k9finance",
      "https://x.com/K9finance",
      "http://www.facebook.com/groups/k9financedao/",
      "https://www.reddit.com/r/k9finance/s/xmmMoYyJ0w",
      "https://www.instagram.com/k9finance?igsh=YnI5bWQ4emhzMjFi&utm_source=qr",
      "https://www.tiktok.com/@k9finance?_t=8jPemHcIMKc&_r=1",
      "https://github.com/K9-Finance-DAO",
    ],
    telegram: "https://t.me/k9finance",
    twitter: "https://x.com/K9finance",
  },
  shib: {
    website: "https://shibatoken.com/",
    other: [
      "https://t.me/ShibaInu_Dogecoinkiller",
      "https://x.com/Shibtoken",
      "https://discord.com/invite/shibatoken",
    ],
    telegram: "https://telegram.me/ShibaInu_Dogecoinkiller",
    twitter: "https://x.com/Shibtoken",
    discord: "https://discord.com/invite/shibatoken",
  },
  cfun: {
    other: [
      "https://corruptfun.com/",
      "https://x.com/CorruptFun",
      "https://t.me/corruptfun",
    ],
  },
  shups: {
    other: [
      "https://shibariumpups.com",
      "https://t.me/Shibariumpups",
      "https://x.com/ShibariumPups",
    ],
  },
  snooze: {
    other: [
      "https://sleepyshibs.com",
      "https://t.me/Sleepyshib",
      "https://x.com/_sleepyshibs_",
    ],
  },
  bonewhale: {
    website: "https://bonewhale.com",
    other: [
      "https://x.com/bonewhaletoken",
      "https://t.me/+S_LoK30EjwthYmI5",
    ],
  },
  coop: {
    website: "https://shibcoop.io/",
    other: [
      "https://shibcoop.io/",
      "https://t.me/shibcoop",
      "https://x.com/shibcoop",
    ],
  },
  oscar: {
    other: [
      "https://oscartoken.com/",
      "https://t.me/oscarshib",
      "https://x.com/oscar_shibainu",
    ],
  },
};

export const SOCIALS_DC: SocialsIndexType = {
  tdh: {
    website: "https://druggedhuskies.club",
    other: [
      "https://druggedhuskies.club",
      "https://t.me/TheDruggedHuskiesOfficial",
      "https://x.com/DruggedHuskies",
      "https://dexscreener.com/dogechain/0x38ed98250f5fd293233edd31ce86d9b8b2e56782",
    ],
  },
};
